import {http} from "./httpClient";

export const searchDemandsWithDocNo = (docNo) =>
	http.get("gotoviy", `/demands`, {params: {demandNumber: docNo}});

export const getDemandFurnitures = (id) =>
	http.get("gotoviy", `/demands/${id}/furnitures`);
